/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOAuth2ClientInfoResponse
 */
export interface GetOAuth2ClientInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof GetOAuth2ClientInfoResponse
     */
    clientName: string;
    /**
     * 
     * @type {string}
     * @memberof GetOAuth2ClientInfoResponse
     */
    clientRedirectUrl: string;
}

/**
 * Check if a given object implements the GetOAuth2ClientInfoResponse interface.
 */
export function instanceOfGetOAuth2ClientInfoResponse(value: object): value is GetOAuth2ClientInfoResponse {
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('clientRedirectUrl' in value) || value['clientRedirectUrl'] === undefined) return false;
    return true;
}

export function GetOAuth2ClientInfoResponseFromJSON(json: any): GetOAuth2ClientInfoResponse {
    return GetOAuth2ClientInfoResponseFromJSONTyped(json, false);
}

export function GetOAuth2ClientInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOAuth2ClientInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientName': json['clientName'],
        'clientRedirectUrl': json['clientRedirectUrl'],
    };
}

export function GetOAuth2ClientInfoResponseToJSON(json: any): GetOAuth2ClientInfoResponse {
    return GetOAuth2ClientInfoResponseToJSONTyped(json, false);
}

export function GetOAuth2ClientInfoResponseToJSONTyped(value?: GetOAuth2ClientInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientName': value['clientName'],
        'clientRedirectUrl': value['clientRedirectUrl'],
    };
}

